import BaseApiClient from "./base-client";
class ActivitySummaryApi extends BaseApiClient {
    activityPath = (studyId, activityId) => `/api/studies/${studyId}/activities/${activityId}/summary`;
    // get() doesn't wrap Axios errors (only the mutating verbs do), so wrap here: a persisted
    // generation failure surfaces via this GET as an HTTP error, and the store needs the
    // structured {statusCode, details} shape to render the specific failure reason.
    fetchSummary = (studyId, activityId) => this.get(this.activityPath(studyId, activityId)).catch((e) => {
        throw this.wrapError(e);
    });
    // POST only enqueues the async job. The generated summary (or an error) comes
    // back via the polling GET once the @Async job has persisted a result.
    generateSummary = (studyId, activityId) => this.post(`${this.activityPath(studyId, activityId)}/generate`);
    static instance = new ActivitySummaryApi();
}
export default ActivitySummaryApi.instance;
